import { render, staticRenderFns } from "./modal_comandas_teste.vue?vue&type=template&id=acd4695e&scoped=true"
import script from "./modal_comandas_teste.vue?vue&type=script&lang=js"
export * from "./modal_comandas_teste.vue?vue&type=script&lang=js"
import style0 from "./modal_comandas_teste.vue?vue&type=style&index=0&id=acd4695e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd4695e",
  null
  
)

export default component.exports